<template>
  <UtilButton @click.native.stop.prevent="watchListing()" :loading="watchPostApi.loading || saving" textLink>
    <template v-if="iconOnly">
      <span v-if="compIsWatching" class="text-red-500">
        <FontAwesomeIcon :icon="faHeartSolid" fixed-width />
      </span>

      <span v-else class="hover:text-red-500">
        <FontAwesomeIcon :icon="faHeart" fixed-width class="" />
      </span>
    </template>

    <template v-else>
      <span v-if="compIsWatching" class="text-red-500">
        <FontAwesomeIcon :icon="faHeartSolid" fixed-width />
        <span>Watching</span>
      </span>

      <span v-else class="hover:text-red-500">
        <FontAwesomeIcon :icon="faHeart" fixed-width />
        <span>Watch</span>
      </span>
    </template>
  </UtilButton>
</template>

<script>
import { mapState } from 'vuex'
import { faHeart } from '@fortawesome/pro-regular-svg-icons'
import { faHeart as faHeartSolid } from '@fortawesome/pro-solid-svg-icons'
import UtilButton from '@/components/utils/UtilButton'
import LegacyApi from '../../lib/api/legacy'

export default {
  name: 'ListingShare',
  components: {
    UtilButton
  },
  props: {
    // Accept either ref or code, as Algolia doesn't use Ref
    listingRef: String,
    listingCode: String,
    iconOnly: Boolean
  },
  data() {
    return {
      watchPostApi: new LegacyApi(),
      saving: false,
      faHeart,
      faHeartSolid
    }
  },
  computed: {
    ...mapState({
      watchlistApi: state => state.watchlist
    }),

    compIsWatching() {
      return this.watchlistApi.data.find(
        listing => listing.listingRef === this.listingRef || listing.listingCode === this.listingCode
      )
    }
  },
  methods: {
    async watchListing() {
      if (!this.appIs.auth) {
        this.$store.dispatch('modal/showModal', {
          modalName: 'ModalAuthLogin',
          modalData: { redirectToDashboard: false, message: this.$t('listing.loginToWatch') }
        })

        return false
      }

      // We use our own flag instead of the usual api.loading because we don't
      // want to see a bunch of spinners on initial load on the search page
      this.saving = true

      try {
        await this.watchPostApi.post('listings.watch', {
          listingRef: this.listingRef,
          listingCode: this.listingCode
        })

        await this.$store.dispatch('watchlist/getWatchlist')
      } catch (error) {
        this.$notify.floatError('Error updating watchlist, press refresh and try again')
      }

      this.saving = false
    }
  }
}
</script>
